import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ResourceConfigItem {
    res_type: string;
    displayName: string;
    icon: string;
    visibleToRoles: string[];
    visibleToProducts: string[];
    action: {
        default: string;
    };
    action_when_file_not_found: {
        default: string;
    };
    modal?: {
        buttonText: string;
        description: string;
        link: string;
        showRedirectButton: boolean;
        title: string;
    };
}

interface ResourceConfigData {
    resourceConfig: ResourceConfigItem[];
}

interface ResourceConfigResponse {
    success: boolean;
    data: ResourceConfigData;
}

interface ResourceConfigState {
    resourceConfigData: ResourceConfigItem[];
    resourceConfigLookup: { [key: string]: ResourceConfigItem };
}

const initialState: ResourceConfigState = {
    resourceConfigData: [],
    resourceConfigLookup: {},
};

const resourceConfigSlice = createSlice({
    name: 'resourceConfig',
    initialState,
    reducers: {
        setResourceConfig: (
            state,
            action: PayloadAction<ResourceConfigResponse>
        ) => {
            const resourceConfigData = action.payload.data.resourceConfig;
            // Create a lookup map from the resource config data
            const resourceConfigLookup = resourceConfigData.reduce(
                (acc, item: ResourceConfigItem) => {
                    acc[item.displayName] = item;
                    return acc;
                },
                {} as { [key: string]: ResourceConfigItem }
            );

            state.resourceConfigData = resourceConfigData;
            state.resourceConfigLookup = resourceConfigLookup;
        },
    },
});

export const { setResourceConfig } = resourceConfigSlice.actions;

export default resourceConfigSlice.reducer;
